<div class="pagers">

  <sc-master-detail [selection]="[selectedPager]" [data]="pagers" (selectionChanged)="onSelectionChanged($event);"
    [newStyle]="true" (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <sc-padding>
      <mat-tab-group>
        <mat-tab [label]="'base-data' | translate: ['tmc-yard.pager.entity.base-data', translationService.language, translationService.revision]">

          <sc-scroll-pane>
            <form #pagerForm="ngForm" class="form no-field-space">
              <sc-padding>
                <sc-flex vertical stretchContent *ngIf="workingCopyDetails != null"
                  class="no-field-space">
                  <mat-form-field appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.pager.number.label"></sc-dictionary-label>
                    </mat-label>
                    <input [(ngModel)]="workingCopyDetails.nbr" #ctrlNumber="ngModel" name="nbr" matInput
                      [required]="true" [maxlength]="255" />
                  </mat-form-field>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <mat-form-field appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.pager.serialnumber.label"></sc-dictionary-label>
                    </mat-label>
                    <input [(ngModel)]="workingCopyDetails.serialNbr" name="serialNbr" matInput
                      [required]="false" [maxlength]="255" />
                  </mat-form-field>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <mat-form-field appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.currentPosition.hint"></sc-dictionary-label>
                    </mat-label>
                    <textarea [(ngModel)]="workingCopyDetails.hint" name="hint" matInput #ctrlHint="ngModel"
                      [required]="false"></textarea>
                  </mat-form-field>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <mat-checkbox [(ngModel)]="workingCopyDetails.available" name="available">
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.pager.available.label"></sc-dictionary-label>
                  </mat-checkbox>
                </sc-flex>
              </sc-padding>
            </form>
          </sc-scroll-pane>
        </mat-tab>

        <mat-tab [label]="'report' | translate: ['tmc-yard.pager.entity.report', translationService.language, translationService.revision]">
          <sc-content-spacer vertical></sc-content-spacer>
          <app-equipment-log [equipmentIdentifier]="equipmentIdentifier"></app-equipment-log>
        </mat-tab>


        <ng-template masterDetailToolbar>
          <div class="spacer grow"></div>
          <sc-cancel-button  class="config-changed-button" (click)="cancel()"
          [disabled]="!cancelEnabled"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
        </ng-template>

      </mat-tab-group>

    </sc-padding>

  </sc-master-detail>

</div>
